import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Platform } from "@ionic/angular";
import * as $ from "jquery";
import { GlobalsService } from "src/app/api/globals.service";
import { StorageService } from "src/app/services/storage.service";
import { TimerService } from "src/app/services/timer.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-memoria",
  templateUrl: "./memoria.component.html",
  styleUrls: ["./memoria.component.scss"],
})
export class MemoriaComponent implements OnInit {
  @Input() public curso: any;
  @Input() public DATA: any;
  @Input() public OPCIONES: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();
  private ID_TIPO = 5;
  private ID_ACTIVIDAD = 0;

  private readonly table = "actividades_respuestas_data";

  memoriaSize: any = { x: 6, y: 6 };
  memoriaArrayObj: any = [];
  memoriaArray: any = [];
  memObjItems: any = [];
  cronoleoUrl: string;
  dataPuzzle: any = [];

  matches: any = [];
  codes: any = [];

  public activityCourse: any;
  isDevice: boolean = false;
  constructor(
    private storageService: StorageService,
    private platform: Platform,
    public globals: GlobalsService,
    private timerService: TimerService
  ) {
    this.isDevice = false;
  }
  inicio_actividad_key: string;
  ngOnInit() {
    this.name.emit("Memoria");
    this.cronoleoUrl = environment.host;
    console.log("DATA ->memoria: ", this.DATA);
    console.log("DATA ->curso: ", this.curso);
    this.ID_ACTIVIDAD = this.DATA.id_actividad;
    this.dataPuzzle = this.OPCIONES;

    //this.memoriaInit();
    /******************* */
    let _id_librocurso = this.ID_ACTIVIDAD;
    let id_tipo = this.ID_TIPO;
    let id_ejercicio = this.DATA.id;
    let _id_curso = this.curso.id;
    let _tipo = this.ID_TIPO_LC;
    let _id_user = this.curso.id_user;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
    console.log("DATA ->KEY:", key);
    this.inicio_actividad_key = key;
    /******************* */
    this.platform.ready().then(() => {
      this.isDevice = this.globals.isMobile;
      this.getStorage();
    });
  }

  memoriaInit() {
    //memoriaArrayObj
    return new Promise((resolve) => {
      this.memoriaArrayObj = [];
      this.memoriaArray = [];
      for (let i = 0; i < this.memoriaSize.y; i++) {
        let idY = this.pad(i, 2);
        this.memoriaArrayObj.push({ y: idY, x: [] });
        for (let j = 0; j < this.memoriaSize.x; j++) {
          let idX = this.pad(j, 2);
          this.memObjItems.push("y" + idY + "_x" + idX);

          this.dataPuzzle.forEach((element) => {
            if (element.id_x == "y" + idY + "_x" + idX) {
              let visible = false;

              if (this.matches.indexOf(element.code) !== -1) {
                visible = true;
                this.isvalid.emit(true);
              }
              if (!element.recurso) {
                let recurso = "/assets/no-image.png";

                this.dataPuzzle.forEach((el) => {
                  if (el.code == element.code && el.recurso) {
                    recurso = this.cronoleoUrl + "/" + el.recurso;
                  }
                });

                this.memoriaArrayObj[i].x.push({
                  id: "y" + idY + "_x" + idX,
                  code: element.code,
                  recursos: { b64: null, file: recurso },
                  visible: visible,
                });
              } else
                this.memoriaArrayObj[i].x.push({
                  id: "y" + idY + "_x" + idX,
                  code: element.code,
                  recursos: {
                    b64: null,
                    file: this.cronoleoUrl + "/" + element.recurso,
                  },
                  visible: visible,
                });
            }
          });
        }
        if (i == this.memoriaSize.y - 1) {
          this.validateCompleteExcercise();
          resolve(true);
        }
      }
    });
  }
  pad(str, max) {
    str = str.toString();
    return str.length < max ? this.pad("0" + str, max) : str;
  }

  matchImg(id, code) {
    if (this.matches.indexOf(code) !== -1) {
      return;
    }
    if (this.codes.indexOf(id) !== -1) {
      return;
    }
    this.codes.push(id);
    if (this.codes.length == 2) {
      let IMG1;
      let IMG2;
      let final = false;
      this.memoriaArrayObj.forEach((element) => {
        let array = element.x;
        if (final) {
          return;
        }
        array.forEach(async (elem) => {
          if (elem.id == this.codes[0]) {
            IMG1 = elem;
            IMG1.visible = true;
          }
          if (elem.id == this.codes[1]) {
            IMG2 = elem;
            IMG2.visible = true;
          }
          if (IMG1 && IMG2) {
            if (IMG1.code == IMG2.code) {
              IMG1.visible = true;
              IMG2.visible = true;
              if (
                this.matches.find((test) => test === IMG1.code) === undefined
              ) {
                this.matches.push(IMG1.code);
                let uniqueChars = [...new Set(this.matches)]; //eliminar duplicados
                this.matches = uniqueChars;
                this.Storage(this.matches);
              }
            } else {
              await new Promise((f) => setTimeout(f, 1000));
              IMG1.visible = false;
              IMG2.visible = false;
            }
            this.codes = [];
            final = true;
            return;
          }
        });
      });
    } else if (this.codes.length == 1) {
      this.memoriaArrayObj.forEach((element) => {
        let array = element.x;
        array.forEach((elem) => {
          if (elem.id == this.codes[0]) {
            elem.visible = true;
          }
          if (elem.id == this.codes[1]) {
            elem.visible = true;
          }
        });
      });
    }
    this.validateCompleteExcercise();
  }
  sqliteStorage: boolean = false;
  sqliteStorageData: any = null;
  async getStorage() {
    let activityCourse: any;
    this.ID_ACTIVIDAD;
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        activityCourse = res.find(
          (x) => x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
        );
        activityCourse.data.forEach((element2, j) => {
          if (
            element2.id == this.DATA.id &&
            element2.id_actividad == this.ID_ACTIVIDAD &&
            element2.id_tipo == this.ID_TIPO
          ) {
            let respuestas = element2;
            this.matches = respuestas.respuesta.r;
          }
        });
        this.memoriaInit();
      } else {
        this.memoriaInit();
      }
    });
  }
  Storage(respuesta: any) {
    /************************************* */
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          //let data:any = this.activityCourse.data;
          this.activityCourse.forEach((element, i) => {
            let find: boolean = false;
            if (
              element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD
            ) {
              find = true;
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            } else {
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        console.log("storageService error", err);
      });
    /************************************* */
  }

  validateCompleteExcercise() {
    const principal = Array.from(
      new Set(this.memoriaArrayObj.flatMap((obj) => obj.x.map((x) => x.code)))
    );
    let result = principal.every((element) => this.matches.includes(element));
    this.isvalid.emit(result);
  }
}
